
const GradeStringMap = {
  PreKindergarten: 'Pre-Kindergarten',
  Kindergarten: 'Kindergarten',
  FirstGrade: '1st Grade',
  SecondGrade: '2nd Grade',
  ThirdGrade: '3rd Grade',
  FourthGrade: '4th Grade',
  FifthGrade: '5th Grade',
  SixthGrade: '6th Grade',
  SeventhGrade: '7th Grade',
  EighthGrade: '8th Grade',
  NinthGrade: '9th Grade',
  TenthGrade: '10th Grade',
  EleventhGrade: '11th Grade',
  TwelfthGrade: '12th Grade',
  CollegeFreshman: 'College Freshman',
  CollegeSophomore: 'College Sophomore',
  CollegeJunior: 'College Junior',
  CollegeSenior: 'College Senior',
  GraduateStudent: 'Graduate Student',
  AdultLearner: 'Adult Learner'
};

export const gradesHiddenToVt4sUsers = new Set([
  GradeStringMap.CollegeFreshman,
  GradeStringMap.CollegeSophomore,
  GradeStringMap.CollegeJunior,
  GradeStringMap.CollegeSenior,
  GradeStringMap.GraduateStudent,
  GradeStringMap.AdultLearner
]);

export default GradeStringMap;
